import React, { useCallback, useEffect, useState } from 'react'
import { Combobox, ComboboxInput, ComboboxPopover, ComboboxList, ComboboxOption } from "@reach/combobox";
import usePlacesAutocomplete, { getGeocode, getLatLng, getDetails } from "use-places-autocomplete";
import "@reach/combobox/styles.css";
import {
  useJsApiLoader,
  GoogleMap,
  Marker,
  DirectionsRenderer,
} from '@react-google-maps/api'
import { Grid } from '@mui/material';
import Geocode from "react-geocode";
import { BtnConfirm } from 'components/Common/Button';
import { currentLanguage } from 'service/CommonFunction/AxiosConfig';

// const defaultCenter = { lat: 13.756525, lng: 100.558107 };

Geocode.setApiKey(process.env.REACT_APP_GOOGLE_MAPS_API_KEY);
Geocode.setRegion("th");
Geocode.setLanguage("th");
Geocode.enableDebug();

const GoogleMapComp = (props) => {

  const { MapHeight, oLocationCurrent, setoLocationCurrent,onSetDataAddress } = props

  const { ready, value, setValue, suggestions: { status, data }, clearSuggestions } = usePlacesAutocomplete({
    requestOptions: {
      /* Define search scope here */
    },
    debounce: 300,
  });


  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries: ['places'],
    id: 'google-map-script',

  })

  const containerStyle = {
    width: '100%',
    height: MapHeight ? MapHeight : '600px',
    borderRadius: '10px'
  };
  const [map, setMap] = useState(null)
  // const [LocationCurrent, setoLocationCurrent] = useState({ lat: 13.756525, lng: 100.558107 });

  useEffect(() => {
      if(oLocationCurrent?.lat){
        setoLocationCurrent({ lat: oLocationCurrent?.lat, lng: oLocationCurrent?.lng })
      }
      else
      {
        navigator.geolocation.getCurrentPosition((position)=>{
          const newlat = position.coords.latitude;
          const newlng = position.coords.longitude;
          setoLocationCurrent({ lat: newlat, lng: newlng })
        });
      }
  }, [])


  if (!isLoaded) {
    return <>Loading Map</>
  }

  const handleSelectDrop = async (val: string) => {
    setValue(val, false);
    clearSuggestions();
    const results = await getGeocode({ address: val });
    const { lat, lng } = await getLatLng(results[0]);
    setoLocationCurrent({ lat: lat, lng: lng })
    let address = await onGetAddressfromLatLng(lat,lng)
    if(onSetDataAddress){
      onSetDataAddress(lat,lng,address)
    }
  };

  const getLatLong = async (event) => {
    const newlat = event.latLng.lat();
    const newlng = event.latLng.lng();

    let address = await onGetAddressfromLatLng(newlat,newlng)
    setoLocationCurrent({ lat: newlat, lng: newlng })
    if(onSetDataAddress){
      onSetDataAddress(newlat,newlng,address)
    }
  }

  const handleSelect = (suggestion) => () => {
    let desc = suggestion.description;
    setValue(desc, false);
    clearSuggestions();
    getGeocode({ address: desc }).then((results) => {
      const { lat, lng } = getLatLng(results[0]);
      setoLocationCurrent({ lat: lat, lng: lng })
      if(onSetDataAddress){
        onSetDataAddress(lat,lng,desc)
      }
    });
  };

  const onGetAddressfromLatLng = async (ParamLat, ParamLng)=>{
    let address = "";
    await Geocode.fromLatLng(ParamLat, ParamLng).then(
      (response) => {
        address = response.results[0].formatted_address;
      },
      (error) => {
        console.error("Get Address Error",error);
      }
    );
    return address;
  }

  const renderSuggestions = () =>
    data.map((suggestion) => {
      const {
        place_id,
        structured_formatting: { main_text, secondary_text },
      } = suggestion;

      return (
        <li key={place_id} onClick={handleSelect(suggestion)} style={{ padding: '8px 10px' }}>
          <strong>{main_text}</strong> <small>{secondary_text}</small>
        </li>
      );
    });

  return (
    <>
      <div style={{ width: '100%', height: '100%', position: 'relative' }}>
        <GoogleMap
          center={oLocationCurrent}
          zoom={15}
          mapContainerStyle={containerStyle}
          options={{
            zoomControl: false,
            streetViewControl: false,
            mapTypeControl: false,
            fullscreenControl: false,
          }}
          onLoad={map => setMap(map)}
        >
          <Marker
            position={oLocationCurrent}
            onDragEnd={ async (e) => { await getLatLong(e) }}
            draggable={true}
          />
        </GoogleMap>
        <Grid container justifyContent="space-between" alignItems="center" style={{ position: "absolute", top: '0em', left: '0em', padding: "1rem" }}>
          <Grid item xs={12} sm={8} md={6} lg={4}>
            <Combobox onSelect={handleSelectDrop}>
              <ComboboxInput
                placeholder= { currentLanguage() == "th" ? "ค้นหา" : "Search"}
                value={value}
                onChange={e => setValue(e.target.value)}
                style={{
                  padding: '0.5rem 0.7rem',
                  color: '#718096',
                  width: '100%',
                  borderRadius: '25px'
                }}
              />
              <ComboboxPopover style={{ zIndex: 9999 }}>
                <ComboboxList>
                  {
                    status === "OK" ?
                      // data.map(({ place_id, description }) => (
                      //   <ComboboxOption key={place_id} value={description} />
                      // ))
                      renderSuggestions()
                      :
                      null
                  }
                </ComboboxList>
              </ComboboxPopover>
            </Combobox>
          </Grid>
        </Grid>
      </div>

    </>
  )
}

export default GoogleMapComp